import React from "react";
import { bool, element, string, array, oneOfType } from "prop-types";

const EventCard = ({
    title,
    image,
    link,
    linkLabel,
    linkTarget,
    startDate,
    endDate,
    comingSoon,
    venue,
    address
}) => (
    <div className="EventCard">
        <div className="EventCardImage">
            <a href={link} target={linkTarget}>
                <img src={image} alt={title} />
            </a>
        </div>
        <div className="EventCardHeader">
            {comingSoon
                ? <h3 className="EventCardSubTitle">Dates Coming Soon</h3>
                : endDate
                    ? <h3 className="EventCardSubTitle">{startDate} - {endDate}</h3>
                    : <h3 className="EventCardSubTitle">{startDate}</h3>
            }
        </div>
        <div className="EventCardBody">
            <h3 className="EventCardTitle">{title}</h3>
            <div className="EventCardInfo">
                {venue && address && (
                    <div className="EventCardLocation">
                        {venue && (
                            <p className="EventCardVenue"><i className="far fa-building fa-lg"></i>{venue}</p>
                        )}
                        {address && (
                            <p className="EventCardAddress"><i className="far fa-map-marker-alt fa-lg"></i>{address}</p>
                        )}
                    </div>
                )}
                <a className="btn btn-outline-lx" href={link} target={linkTarget} >{linkLabel}</a>
            </div>
        </div>
    </div>
);

EventCard.defaultProps = {
    linkLabel: "View Details",
    linkTarget: "_self"
};

EventCard.propTypes = {
    title: string,
    image: string,
    link: string,
    linkTarget: string,
    linkLabel: string,
    startDate: oneOfType([
        bool,
        element,
        string,
        array
    ]),
    endDate: oneOfType([
        bool,
        element,
        string,
        array
    ]),
    comingSoon: bool,
    venue: string,
    address: string
};

export default EventCard;